export const BORDER_RADIUS = '7px';

export const BASE_COLORS = {
  white: '#ffffff',
  black: '#000000',
  green: '#008000',
  orange: '#ffb155',
  gray: '#808080',
  lightgrey: '#c5d3e0',
  violet: '#ee82ee',
  lightgreen: '#89dca0',
  pink: '#ffc0cb',
  blue: '#0000ff',
  skyblue: '#35a0dc',
  red: '#ff5252',
} as const;

export const LAYOUT = {
  mobile: {
    paddingVertical: '0.2rem',
    paddingHorizontal: '0.5rem',
    headerHeight: '3.7rem',
    headerPadding: '0.5rem',
  },
  desktop: {
    paddingVertical: '0.2rem',
    paddingHorizontal: '0.5rem',
    headerHeight: '3.7rem',
  },
} as const;

export const FONT_FAMILY = {
  main: 'Montserrat',
  secondary: 'Lato',
} as const;

export const FONT_SIZE = {
  xxs: '0.55rem',
  xs: '0.775rem',
  md: '0.9rem',
  lg: '1rem',
  xl: '1.1rem',
  xxl: '1.25rem',
  xxxl: '1.35rem',
  xxxxl: '1.5rem',
} as const;

export const FONT_WEIGHT = {
  thin: '100',
  extraLight: '200',
  light: '300',
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  extraBold: '800',
  black: '900',
} as const;

export const BREAKPOINTS = {
  xs: 360,
  sm: 568,
  md: 768,
  lg: 992,
  xl: 1280,
  xxl: 1920,
} as const;

const getMedia = <T extends number>(breakpoint: T): `(min-width: ${T}px)` => `(min-width: ${breakpoint}px)`;

export const media = {
  xs: getMedia(BREAKPOINTS.xs),
  sm: getMedia(BREAKPOINTS.sm),
  md: getMedia(BREAKPOINTS.md),
  lg: getMedia(BREAKPOINTS.lg),
  xl: getMedia(BREAKPOINTS.xl),
  xxl: getMedia(BREAKPOINTS.xxl),
};
